export const ROTATE_HANDLE_PIXEL_SCALE = 240;
export const TRANSLATE_HANDLE_RADIUS = 3;
export const SCALE_HANDLE_RADIUS = 3;
export const SCALE_HANDLE_CUBE_SIDE_LENGTH = 20;
export const SCALE_HANDLE_PIXEL_SCALE = 320;

export const TransformMode = {
  TRANSLATE: 'translate',
  SCALE: 'scale',
  ROTATE: 'rotate',
};

export default {
  TransformMode,
};
